import api from '../../services/assessmentSaved';
export default function (helper) {
    /**
     * Generated store module
     */
    helper.setApi(api);
    const types = helper.types('saved_assessment');
    const state = helper.state();
    const getters = helper.getters();
    const actions = helper.actions({}, 'Saved Assessment');
    const mutations = helper.mutations({}, types, state);

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    };
}